export default __webpack_public_path__ + "static/media/mp4.49345160.png";